import React from 'react';
import { NavLink } from 'react-router-dom';

export class LinkButton extends React.Component{

    constructor(props){
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick(){
        console.log('directing to ' + this.props.to);
    }

    render(){
        
            return(
                <NavLink onClick={this.onClick} to={this.props.to} className={`btn ${this.props.class}`}>{this.props.text}</NavLink>
            );
       
        
    }
}


// WEBPACK FOOTER //
// ./src/app/components/LinkButton.js